import type { ArtifactColumn } from "connected-components/dashboard/modules/ai-artifact/types"

const PER_SHARE_PRICE_LABEL_PATTERN = /\b(?:price|px)\b|\bper[\s-]share\b/i

export function isPerSharePriceColumn(column: ArtifactColumn | undefined): boolean {
  if (!column) {
    return false
  }
  if (typeof column.isPerShare === "boolean") {
    return column.isPerShare
  }
  return PER_SHARE_PRICE_LABEL_PATTERN.test(column.label)
}
